export const parseDoubleEncodedJson = (data: any): any => {
    if (typeof data !== 'string') return data;
    
    try {
        const firstParse = JSON.parse(data);
        if (typeof firstParse === 'string') {
            return JSON.parse(firstParse);
        }
        return firstParse;
    } catch {
        return data;
    }
};
